import TagManager from 'react-gtm-module';
import config from '../config';

export const initializeTagManager = () => {
  TagManager.initialize({
    gtmId: config.GOOGLE_TAG_MANAGER_ID,
  });
};

export function gtag() {
  window.dataLayer?.push(arguments); // eslint-disable-line prefer-rest-params
}

export const initialize = () => {
  initializeTagManager();

  window.dataLayer = window.dataLayer || [];
  window.gtag = gtag;
  gtag('js', new Date());

  gtag('config', config.GOOGLE_ANALYTICS_TRACKING_ID, { optimize_id: config.OPTIMIZE_ID });
};
